import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Loading } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';
import { fetchPartitionBundle } from '@/slices/topicSlice';
import { isVoid } from '@/utils/common';
import Subscriptions from '../BasicPanel/Subscriptions';
import Producer from '../BasicPanel/Producer';
import PartitionSelect from '../components/PartitionSelect';
import PartitionSummary from './PartitionSummary';

function Partition({
  commonProps,
  statsSubscriptions,
  fetchPartitionBundle,
  loading,
  bundle,
  statsProducers,
}) {
  const [currentPart, setCurrentPart] = useState();

  useEffect(() => {
    if (!isVoid(currentPart)) {
      fetchPartitionBundle({
        ...commonProps,
        partition: currentPart,
      });
    }
  }, [currentPart, fetchPartitionBundle, commonProps]);

  return (
    <>
      <PartitionSummary commonProps={commonProps} />
      <Loading delay={300} loading={loading}>
        <PartitionSelect currentPart={currentPart} onChange={setCurrentPart} />
        <Content>
          <Descriptions.Panel title='Bundle' bordered style={{ border: 'none' }}>
            <Descriptions style={{ minHeight: 32 }}>
              {Object.entries(bundle).map(([key, value]) => (
                <Descriptions.Item label={key} value={value} key={key} />
              ))}
            </Descriptions>
          </Descriptions.Panel>
          <Descriptions.Panel title='生产者' bordered style={{ border: 'none' }}>
            <Producer data={statsProducers} />
          </Descriptions.Panel>
          <Descriptions.Panel title='订阅者' bordered style={{ border: 'none' }}>
            <Subscriptions data={statsSubscriptions} />
          </Descriptions.Panel>
        </Content>
      </Loading>
    </>
  );
}

export default connect(
  (state) => ({
    loading: state.topic.partitionBundleFetching,
    statsSubscriptions: state.topic.partitionBundle.statsSubscriptions || [],
    bundle: state.topic.partitionBundle.bundle || {},
    statsProducers: state.topic.partitionBundle.statsProducers || [],
  }),
  {
    fetchPartitionBundle,
  },
)(Partition);

const Content = styled.div`
  border: 1px solid rgba(32, 43, 64, 0.08);
  border-radius: 6px;
`;
